import React from 'react';
import { Match } from '@reach/router';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { GAME_IDS, GAME_SERIES } from '../../constants';
import logos from '../../logos/games-white';

const Bar = styled.div`
  position: fixed;
  z-index: 3;
  top: 0;
  height: 3.5rem;
  line-height: 3.6rem;
  right: 0;
  left: 0;
  font-size: 1em;
  display: flex;
  justify-content: flex-end;
  font-family: DINCondensed-Regular;
  background: rgba(0, 0, 0, 0.8);
`;

const Filler = styled.div`
  height: 3.5rem;
  flex-shrink: 0;
`;

const Flex = styled.div`
  flex: 1;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  height: 3.5rem;
  flex: 1;
`;

const GameButton = styled(Link)`
  width: 6em;
  text-align: center;
  color: inherit;
  text-decoration: none;
  &.active {
    background: ${props => props.theme.primary};
  }
`;

const LinkLogo = styled(Link)`
  height: 100%;
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
`;

const Logo = styled.img`
  height: 65%;
`;

const NavBar = ({ gameId }) => {
  const isActiveGame = GAME_IDS.includes(gameId);
  const series = GAME_SERIES[gameId];

  return (
    <>
      <Filler />
      <Bar>
        <Flex />
        {isActiveGame && (
          <>
            <LinkLogo to={`/games/${gameId}/`}>
              <Logo src={logos[gameId]} />
            </LinkLogo>
            <Match path="/games/:gameId">
              {({ match }) => {
                if (!match) {
                  return null;
                }
                if (!series) {
                  return <Flex />;
                }
                return (
                  <ButtonContainer>
                    {Object.values(series).map(
                      ({ gameId: seriesGameId, label }) => (
                        <GameButton
                          className={gameId === seriesGameId ? 'active' : ''}
                          key={seriesGameId}
                          to={`/games/${seriesGameId}/`}
                        >
                          {label}
                        </GameButton>
                      )
                    )}
                  </ButtonContainer>
                );
              }}
            </Match>
          </>
        )}
      </Bar>
    </>
  );
};

NavBar.propTypes = {
  gameId: PropTypes.string
};

export default NavBar;
